
import moment from 'moment'
let format = date => {
    var objDate = new Date(date)
    var formattedDate = moment(objDate).format('YYYY-MM-DD')
    if(formattedDate === '1970-01-01'){
      formattedDate = '0001-01-01'
    }
    if(formattedDate === 'Invalid date') {
      formattedDate = '0001-01-01'
    }
    return formattedDate
}
export default {
  format
}
